"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Keep = exports.Opt = exports.Has = exports.Mod = exports.Base = void 0;
exports.Base = ({
    type: () => 'base',
    category: () => undefined,
    default: () => undefined,
    enabled: () => true,
    keep: () => false,
    optional: () => false,
    navigate() { return this; },
    pathPush: (p) => p,
    suggest: () => [],
    validate: (_, v) => v,
    validationOption: () => undefined,
    hook(hook, path, ...args) { return hook.base({ node: this }, path, ...args); },
    canUpdate: () => false,
    update: () => []
});
const Mod = (node, mods) => ({
    ...node, ...(typeof mods === 'function' ? mods(node) : mods)
});
exports.Mod = Mod;
const Has = (key, node) => (0, exports.Mod)(node, {
    enabled: (p) => p.push(key).get() !== undefined
});
exports.Has = Has;
function Opt(node) {
    return {
        ...node,
        optional: () => true
    };
}
exports.Opt = Opt;
function Keep(node) {
    return {
        ...node,
        keep: () => true
    };
}
exports.Keep = Keep;
